import { BaseApi } from './base.api.js';

export class FormTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/form-template');
    }
}
